export const drawRectangle = (context, obj, canvasOffset, zoom) => {
  const centerX = obj.x + obj.width / 2;
  const centerY = obj.y + obj.height / 2;

  context.save(); // Save the current state
  context.scale(zoom, zoom);
  context.translate(centerX + canvasOffset.x, centerY + canvasOffset.y); // Move to the center of the rectangle
  context.rotate((obj.rotation * Math.PI) / 180); // Rotate around the center

  // Draw the rectangle
  context.fillStyle = obj.color;
  if (obj.tierColor) context.fillStyle = obj.tierColor;
  if (obj.shape === "circle") {
    context.beginPath();
    context.arc(0, 0, obj.width, 0, Math.PI * 2);
    context.fill();
  }
 if (obj.shape === "arc") {
    context.strokeStyle = obj.color;
    context.lineWidth = obj.lineWidth || 2;
    context.beginPath();

    const startX = -obj.width / 2;
    const endX = obj.width / 2;
    const midX = 0; // Midpoint X
    const curveHeight = obj.curveHeight ?? 30; // Control curve depth (positive = outward, negative = inward)

    // Quadratic curve (easier to control)
    context.moveTo(startX, 0);
    context.quadraticCurveTo(midX, -curveHeight, endX, 0);
    context.stroke();
  } 
  else context.fillRect(-obj.width / 2, -obj.height / 2, obj.width, obj.height);
  const newFont = zoom >= 0.1 || zoom <= 1.5 ? 12 / zoom : 12;
  // Before drawing the text, rotate back to cancel out the rectangle's rotation
  // context.rotate((-obj.rotation * Math.PI) / 180); // Inverse rotation for the text
  context.fillStyle = "white"; // Set text color
  context.font = `700 ${newFont}px Arial`; // Set font size and family
  context.textAlign = "center"; // Center the text horizontally
  context.textBaseline = "middle"; // Center the text vertically
  context.fillText(obj.name, 0, 0); // Draw the text at the rectangle's center

  context.restore(); // Restore the initial context state
};
